/* eslint-disable max-len */
import { Stack, TextInput, Title } from '@mantine/core';
import { defineMessages, useIntl } from 'react-intl';

import styles from '../ParentsDetails.module.scss';

import { useTeamMemberContext } from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/TeamMemberDetailsContext';
import sharedMessages from 'Components/utils/sharedMessages';

const headingId = 'team-member-parents-mothers-details-heading';

const MothersDetails = () => {
    const intl = useIntl();
    const { values } = useTeamMemberContext();
    const mothersData = values.parents?.find((parent) => parent.type === 'mother');

    if (!mothersData) {
        return null;
    }

    return (
        <Stack gap="sm" aria-labelledby={headingId} className={styles.container}>
            <Title order={4} size="h5" id={headingId} className={styles.heading}>{intl.formatMessage(messages.heading)}</Title>
            <TextInput
                id="mother-name-input-in-team-member"
                label={intl.formatMessage(sharedMessages.nameAndSurname)}
                value={mothersData.name}
                disabled
            />
            {mothersData.address && (
                <TextInput
                    id="mother-address-input-in-team-member"
                    label={intl.formatMessage(sharedMessages.address)}
                    value={mothersData.address}
                    disabled
                />
            )}
            <TextInput
                id="mother-email-input-in-team-member"
                label={intl.formatMessage(sharedMessages.email)}
                value={mothersData.email}
                disabled
            />
            {mothersData.phone && (
                <TextInput
                    id="mother-name-phone-number-in-team-member"
                    label={intl.formatMessage(sharedMessages.phoneNumber)}
                    value={mothersData.phone}
                    disabled
                />
            )}
        </Stack>
    );
};

const basePath = 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.Details.Components.TeamMemberParents.TeamMemberParents.Components.MothersDetails.MothersDetails';

const messages = defineMessages({
    heading: {
        id: `${basePath}.heading`,
        defaultMessage: 'Dane matki',
    },
});

export default MothersDetails;
